import { CSSProperties, useState } from "react";
import Loader from "@/components/Loaders/LoaderCircle/Loader";

interface AppImageProps {
  src: string;
  alt?: string;
  onClick?: () => void;
  style?: CSSProperties;
}

const AppImage = (props: AppImageProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="relative block w-full box-border">
      {isLoading && (
        <div className="absolute inset-0  flex items-center justify-center z-[1] rounded-lg">
          <Loader isLoading={true} width={32} height={32} color="white" />
        </div>
      )}
      <img
        onClick={props.onClick}
        src={props.src}
        alt={props.alt}
        onLoad={() => setIsLoading(false)}
        style={{ opacity: isLoading ? 0 : 1, ...props.style }}
        className="transition-opacity duration-500 ease-in-out w-full h-auto object-cover rounded-lg"
        loading="lazy"
      />
    </div>
  );
};

export default AppImage;
